import {DeviceType} from "@hybird/device/config";
import {AplusV2DeviceProvide} from "@hybird/device/terminal/aplusv2";

class ASmartV2DeviceProvide extends AplusV2DeviceProvide {

  constructor(deviceConnectProvide) {
    super(deviceConnectProvide);
  }

  isSupport(deviceInfo) {
    return DeviceType.a_smart === deviceInfo.modelType;
  }
}

export {ASmartV2DeviceProvide};